/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S12_Li3_DescInputs */

const tr_iade_iptal_s12_li3_desc = /** @type {(inputs: Iade_Iptal_S12_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pazaryeri komisyonu, kargo bedeli, QNB e-Fatura kontör tüketimi vb. üçüncü taraf bedelleri, ilgili sağlayıcıların kendi iade politikalarına tabidir.`)
};

const en_iade_iptal_s12_li3_desc = /** @type {(inputs: Iade_Iptal_S12_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Third party fees such as marketplace commission, shipping fees and QNB e-Fatura quota consumption are subject to the refund policies of the relevant providers.`)
};

const de_iade_iptal_s12_li3_desc = /** @type {(inputs: Iade_Iptal_S12_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entgelte Dritter wie Marktplatzprovision, Versandkosten oder der Verbrauch von QNB e-Fatura Kontingenten unterliegen den Erstattungsrichtlinien der jeweiligen Anbieter.`)
};

const ru_iade_iptal_s12_li3_desc = /** @type {(inputs: Iade_Iptal_S12_Li3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Суммы третьих лиц, такие как комиссия торговой площадки, стоимость доставки, расход квот QNB e-Fatura и т. п., регулируются политиками возврата соответствующих поставщиков.`)
};

/**
* | output |
* | --- |
* | "Third party fees such as marketplace commission, shipping fees and QNB e-Fatura quota consumption are subject to the refund policies of the relevant providers." |
*
* @param {Iade_Iptal_S12_Li3_DescInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s12_li3_desc = /** @type {((inputs?: Iade_Iptal_S12_Li3_DescInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S12_Li3_DescInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s12_li3_desc(inputs)
	if (locale === "de") return de_iade_iptal_s12_li3_desc(inputs)
	if (locale === "ru") return ru_iade_iptal_s12_li3_desc(inputs)
	return tr_iade_iptal_s12_li3_desc(inputs)
});